import dayjs, {Dayjs} from 'dayjs';

/** 罚单生成时间筛选最多可选天数（含起止当天） */
export const CREATION_TIME_MAX_DAYS = 30;

/** 默认筛选最近几天（含今天） */
export const CREATION_TIME_DEFAULT_DAYS = 7;

export type CreationTimeRange = [Dayjs, Dayjs];

export const getDefaultCreationTimeRange = (): CreationTimeRange => {
    const today = dayjs();
    return [today.subtract(CREATION_TIME_DEFAULT_DAYS - 1, 'day').startOf('day'), today.endOf('day')];
};

/**
 * RangePicker 的 disabledDate：选中一端后，另一端只能落在 30 天（含）以内。
 * 30 天含起止当天即相差 29 天，超过即禁用；`info.from` 由 antd 提供，双向生效。
 */
export const disableBeyondMaxDays = (current: Dayjs, info?: {from?: Dayjs}): boolean => {
    if (!current || !info?.from) return false;
    return Math.abs(current.startOf('day').diff(info.from.startOf('day'), 'day')) > CREATION_TIME_MAX_DAYS - 1;
};

/** 按浏览器时区取起始日 00:00 与结束日 23:59:59.999，转 ISO 下传；后端按 >= / <= 过滤 */
export const toCreationTimeRangeInput = (
    range?: CreationTimeRange | null,
): {start: string; end: string} | undefined => {
    if (!range) return undefined;
    return {start: range[0].startOf('day').toISOString(), end: range[1].endOf('day').toISOString()};
};
